import React, { useState, FunctionComponent, useEffect } from 'react';
import { Presentation } from './presentation';
import type { Employment } from '../../../types/toppage';
import { getEmployments } from '../../../services/toppage';

export const Component: FunctionComponent = () => {
  const [employments, setEmployments] = useState<Employment[]>([]);

  useEffect(() => {
    const request = async () => {
      const data = await getEmployments();
      setEmployments(data);
    };
    request();
  }, []);

  return <Presentation employments={employments} />;
};
